module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0159.jpg?v=32b96214";